import Sku from '../models/sku';
import Currency from '../models/currency';
import namespace from '../../upi/namespace';

var SkuList = Backbone.Collection.extend( {

    model: Sku,

    getSkuByOptions: function ( groupId, options ) {
        // if a groupId provided, then filter skus by that group, else just search from entire list
        if ( _.isObject( groupId ) ) {
            options = groupId;
            groupId = null;
        }
        var skuList = this.models;

        if ( groupId ) {
            skuList = _.filter( skuList, function ( sku ) {
                return sku.get( 'groupId' ) === groupId;
            } );
        }

        return _.find( skuList, function ( sku ) {
            return _.isEqual( options, sku.get( 'options' ) );
        } );
    },

    getSelectedSku: function () {
        return this.findWhere( {selected: true} );
    },

    filterByOptionId: function ( optionGroupId, optionId ) {
        return this.filter( function ( sku ) {
            return sku.get( 'options' )[optionGroupId] === optionId;
        } );
    },

    hasPriceRestrictions: function () {
        return this.some( function ( item ) {
            return item.get( 'customerPrice' ) == -1;
        } );
    },

    filterByOptionGroupId: function ( optionGroupId ) {
        return this.filter( function ( sku ) {
            return sku.get( 'groupId' ) === optionGroupId;
        } );
    },

    getOptionIdsByAvailability: function ( optionGroupId ) {
        return this.map( function ( sku ) {
            return sku.get( 'options' )[optionGroupId];
        } );
    },

    getAvailableOptionGroupsHash: function () {
        var optionGroups = {};

        this.each( function ( sku ) {
            var options = sku.get( 'options' );
            for ( var opt in options ) {
                if ( options.hasOwnProperty( opt ) ) {
                    if ( !optionGroups[opt] ) {
                        optionGroups[opt] = [];
                    }
                    optionGroups[opt].push( options[opt] );
                }
            }
        } );

        for ( var key in optionGroups ) {
            if ( optionGroups.hasOwnProperty( key ) ) {
                optionGroups[key] = _.uniq( optionGroups[key].sort(), true );
            }
        }

        return optionGroups;
    },

    getPriceRange: function () {
        // filter out unpriced items and sort by ascending values
        var pricedItems = this.pluck( 'customerPrice' ).filter( function ( item ) {
                // filter out non-currency values such as null and -1 used for price restrictions
                return item !== null && item > 0;
            } ).sort( function ( a, b ) {
                return a - b;
            } ),
            priceList = new Currency( {priceList: pricedItems} ),
            currency = priceList.toCurrency( 'priceList' );

        return {high: _.last( currency ), low: _.first( currency )};
    },

    getIds: function () {
        return this.map( function ( sku ) {
            return sku.get( 'id' );
        } );
    },

    getIdsByAvailability: function () {
        return this.filter( function ( sku ) {
            return sku.get( 'isOrderable' );
        } ).map( function ( sku ) {
            return sku.get( 'id' );
        } );
    }

} );

export default namespace( 'apps.productpage' ).SkuList = SkuList;
